module.exports = __webpack_public_path__ + "img/r-166.6b02db1a.jpg";